import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsSymphonyComponent } from './simple-icons-symphony.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsSymphonyComponent ],
    exports:      [ SimpleIconsSymphonyComponent ],
    bootstrap:    []
})
export class SimpleIconsSymphonyModule {}
